import React from 'react'
import { Link } from 'react-router-dom';

interface IButton extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
    onClick?: any;
    loading?: boolean;
    show?: boolean;
    text?: string;
}

const Button = ({ text, children, className, type = 'button', onClick, style, loading = false, disabled, show = true, id, ...props }: IButton) => {
    return (
        <>
            {show &&
                (loading ?
                    <button 
                        className={className || 'com-btn my-5 mx-auto'} 
                        type='button' 
                        disabled 
                        aria-busy="true"
                        aria-live="polite"
                        aria-label={props['aria-label'] || (typeof text === 'string' ? `Loading ${text}` : 'Loading...')}
                        {...props}
                    >
                        <div className='ellipsis-loader'>
                            <div className='single-ellipsis'></div>
                            <div className='single-ellipsis'></div>
                            <div className='single-ellipsis'></div>
                        </div>
                    </button>
                    :
                    // <button onClick={onClick} className={className || ''} style={style} type={type} disabled={disabled}>{text}</button>
                    <button onClick={onClick} id={id} className={className || ''} style={style} type={type} disabled={disabled} {...props}>
                        {children || text}
                    </button>
                )
            }
        </>
    )
}


export default Button